import { render, staticRenderFns } from "./NetworkStreamax.vue?vue&type=template&id=01f30cb4&scoped=true&"
import script from "./NetworkStreamax.vue?vue&type=script&lang=ts&"
export * from "./NetworkStreamax.vue?vue&type=script&lang=ts&"
import style0 from "./NetworkStreamax.vue?vue&type=style&index=0&id=01f30cb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f30cb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('01f30cb4', component.options)
    } else {
      api.reload('01f30cb4', component.options)
    }
    module.hot.accept("./NetworkStreamax.vue?vue&type=template&id=01f30cb4&scoped=true&", function () {
      api.rerender('01f30cb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConfiguracionCamaras/Streamax/Network/NetworkStreamax.vue"
export default component.exports